import { TypographySM } from "@/components/typography/SM";
import { Users } from "lucide-react";
import { LinkReference } from "./LinkReference";
import { OnboardingStep } from "./OnboardingStep";

interface Props {
  isCompleted: boolean;
}

export function InviteUserStep({ isCompleted }: Props) {
  return (
    <OnboardingStep
      title="Invite someone to your organization"
      icon={<Users size={18} />}
      isCompleted={isCompleted}
    >
      <TypographySM className="mb-2 leading-6">
        The more the merrier. Numerous organizations are great for collaborating
        with others.
      </TypographySM>

      <TypographySM className="leading-6">
        Go to the <LinkReference icon={Users}>Members</LinkReference> page to
        make changes to your organization&apos;s members.
      </TypographySM>
    </OnboardingStep>
  );
}
